import { render, staticRenderFns } from "./RightDetail.vue?vue&type=template&id=0433ef94&scoped=true"
import script from "./RightDetail.vue?vue&type=script&lang=js"
export * from "./RightDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0433ef94",
  null
  
)

export default component.exports